<p class="alert alert-warning">
    <app-spin-icon></app-spin-icon>
    <span *ngIf="orderStart">Preparing for purchase</span>
    <span *ngIf="paymentPrepare">Handling payment</span>
    <span *ngIf="orderFinalize">Finalizing order and setting up tokens</span>
        <span *ngIf="orderComplete">Order complete! Navigating to complete page</span>
    <span class="ellipses">...</span>
</p>


// WEBPACK FOOTER //
// ./src/app/admin/checkout-status-monitor/checkout-status-monitor.component.html